/**
 * @module support/infinea
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */

import { Injectable } from '@angular/core';

@Injectable()
export class VoidInfineaService {
  constructor() {}

  public displayIpcMessage(message: string): void {}

  public resetIpc(): void {}
}
